import React from 'react'
import { isDynamicImportFailure } from '../../utils/dynamicImportRecovery'

interface LazyChunkErrorBoundaryProps {
  children: React.ReactNode
}

interface LazyChunkErrorBoundaryState {
  hasError: boolean
  isChunkError: boolean
}

export class LazyChunkErrorBoundary extends React.Component<
  LazyChunkErrorBoundaryProps,
  LazyChunkErrorBoundaryState
> {
  state: LazyChunkErrorBoundaryState = {
    hasError: false,
    isChunkError: false,
  }

  static getDerivedStateFromError(error: unknown): LazyChunkErrorBoundaryState {
    return {
      hasError: true,
      isChunkError: isDynamicImportFailure(error),
    }
  }

  private handleReload = () => {
    window.location.reload()
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children
    }

    const title = this.state.isChunkError
      ? 'App update detected'
      : 'Something went wrong'
    const description = this.state.isChunkError
      ? 'A recent deploy changed app files. Reload to continue.'
      : 'Please reload and try again.'

    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-background-100">
        <div className="max-w-md rounded-2xl border border-neutral-200/70 bg-white p-8 text-center shadow-modal">
          <h2 className="font-serif text-fs-600 font-semibold text-ink-700">
            {title}
          </h2>
          <p className="mt-2 font-sans text-fs-400 text-ink-500">
            {description}
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            className="pb-btn pb-btn--md pb-btn--primary mt-6"
          >
            Reload app
          </button>
        </div>
      </div>
    )
  }
}

export default LazyChunkErrorBoundary
